/**
 * @description 获取URL请求参数
 * @author Wynne
 * @date 2021-03-17
 * @param {*} [url=location.href]
 * @return {*}  {Record<string, string>}
 */
export const getQueryString = (url = location.href):{[key:string]:string} => {
  url = url.replace(/#.*/, '');
  const queryMatch = url.match(/([^?=&]+)(=([^&]*))/g);
  return queryMatch
    ? queryMatch.reduce((a:any, v) => (
      a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)
      // eslint-disable-next-line no-sequences
      , a), {})
    : {};
};
